module.exports = __webpack_public_path__ + "static/media/20.3ec6fdb9.png";